import React from 'react';
import 'react-bootstrap-table/dist/react-bootstrap-table-all.min.css';
import 'react-bootstrap-table/css/react-bootstrap-table.css';
import { Route, Switch } from 'react-router-dom';
import FormAddCity from './FormAddCity';
import ListRegion from './ListRegion';
import '../css/Warehouse.css';
import MyUtil from '../../functions/MyUtil';

const Partner = (props) => {
  const { match } = props;
  return (
    <div>
      <Switch>
        {MyUtil.hasPermission(match.url, 'view') && (
          <Route
            exact
            path={`${match.url}`}
            component={() => <ListRegion match_parent={match} />}
          />
        )}
        {MyUtil.hasPermission(match.url, 'add') && (
          <Route path={`${match.url}/add-city`} component={FormAddCity} />
        )}
        {MyUtil.hasPermission(match.url, 'update') && (
          <Route
            path={`${match.url}/edit-city/:city_id`}
            component={FormAddCity}
          />
        )}
      </Switch>
    </div>
  );
};

export default Partner;
